/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A higher-tier room available for the stay's existing dates.
 * @export
 * @interface BetterRoom
 */
export interface BetterRoom {
    /**
     * Room description as returned by the supplier (e.g. "Deluxe King — Ocean View").
     * @type {string}
     * @memberof BetterRoom
     */
    description: string;
    /**
     * Coarse tier classification 1-8 (1=Standard, 2=Superior, 3=Deluxe, 4=Executive,
     * 5=Junior Suite, 6=Suite, 7=Premium Suite, 8=Villa/Residence).
     * 
     * @type {number}
     * @memberof BetterRoom
     */
    tier: number;
}

/**
 * Check if a given object implements the BetterRoom interface.
 */
export function instanceOfBetterRoom(value: object): value is BetterRoom {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    return true;
}

export function BetterRoomFromJSON(json: any): BetterRoom {
    return BetterRoomFromJSONTyped(json, false);
}

export function BetterRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): BetterRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'tier': json['tier'],
    };
}

export function BetterRoomToJSON(json: any): BetterRoom {
    return BetterRoomToJSONTyped(json, false);
}

export function BetterRoomToJSONTyped(value?: BetterRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'tier': value['tier'],
    };
}

